import {
  CustomerDeactivationModalKey,
  CustomerDetailsKey,
  CustomerListPageKey,
  CustomerListTableKey,
  CustomerPendingListTableKey,
  CustomerUploadModalKey
} from '../../TModules';

export const translations = {
  [CustomerListTableKey]: {
    Identifier: 'Kennung',
    Name: 'Name',
    Status: 'Status',
    DateJoined: 'Beitrittsdatum',
    Actions: 'Aktionen',
    SearchCustomers: 'Kunden suchen',
    Activate: 'Aktivieren',
    Deactivate: 'Deaktivieren',
    Active: 'Aktiv',
    Inactive: 'Inaktiv',
    Initial: 'Initial'
  },
  [CustomerUploadModalKey]: {
    HandleUpload: {
      SuccessMessage: 'Datei hochgeladen',
      ErrorMessage: 'Fehler beim Hochladen der Datei.',
      Title: 'Kundendatei hochladen',
      OkText: 'Hochladen',
      CancelText: 'Abbrechen',
      UploadButton: 'Hochladen',
      UploadDraggerMessage:
        'Klicken oder ziehen Sie die Datei in diesen Bereich, um sie hochzuladen',
      DownloadSample: 'Beispiel herunterladen',
      AcceptedFormat: 'Akzeptiertes Format: Nur .txt., .xlsx- oder .csv-Dateien'
    }
  },
  [CustomerPendingListTableKey]: {
    RequestId: 'Anfrage-ID',
    Customer: 'Kunde',
    RequestType: 'Anfragetyp',
    Status: 'Status',
    Comment: 'Kommentar',
    LastUpdated: 'Zuletzt aktualisiert',
    DateOfExpiry: 'Ablaufdatum',
    Actions: 'Aktionen',
    Comments: 'Kommentare',
    ViewDetails: 'Details anzeigen',
    Approve: 'Genehmigen',
    ApproveRequests: 'Anfragen genehmigen',
    CustomerStampView: 'Kundenstempelansicht',
    LoyaltyProgramDetails: 'Bonusprogramm Details',
    CustomerGameView: 'Kundenspielansicht',
    CustomerRewardView: 'Kundenbelohnungsansicht',
    ApproveSelectedButton: 'Ausgewählte genehmigen',
    ReactivateCustomer: 'Kunden Reaktivieren',
    DeactivateCustomer: 'Kunden Deaktivieren',
    VoidVoucher: 'Gutschein Stornieren',
    ModifyVoucher: 'Gutschein Bearbeiten',
    CashbackIssue: 'Cashback Ausgabe',
    Issue: 'Problem',
    Rewards: 'Belohnungen',
    Reward: 'Belohnung',
    Stamps: 'Stempel',
    Gametries: 'Spielversuche',
    GameTries: 'Spielversuche',
    GAMETRIES: 'SPIELVERSUCHE',
    Voucher: 'Gutschein',
    LoyaltyPoints: 'Treuepunkte',
    Cashbackissue: 'Cashback-Ausgabe',
    Loyaltydelete: 'Loyalty-Löschung',
    AddProgressPoints: 'Fortschrittspunkte hinzufügen',
    MarkQuestTaskComplete: 'Quest-Aufgabe als erledigt markieren',
    IssueInstantReward: 'Sofortbelohnung ausstellen',
    IssueRaffleTicket: 'Losticket ausstellen',
    CustomerProgressPointsPendingView: 'Fortschrittspunkte ausstehend',
    CustomerQuestTaskPendingView: 'Quest-Aufgabe ausstehend',
    CustomerInstantRewardPendingView: 'Sofortbelohnung ausstehend',
    CustomerRaffleTicketPendingView: 'Losticket ausstehend',

    ApproveMultipleMessageModal: {
      SuccessMessage: 'Uploads genehmigt',
      FailureMessage: 'Fehler beim Genehmigen der Datei.',
      Title: 'Mehrere Anfragen genehmigen?',
      OkText: 'Ausgewählte genehmigen',
      DescriptionText: `
      Möchten Sie wirklich alle ausgewählten Anfragen genehmigen?
      <br />
      Bitte überprüfen Sie die Details, bevor Sie genehmigen, da diese Aktion nicht rückgängig gemacht werden kann.`
    },
    ApproveRequestModal: {
      SuccessMessage: 'Anfrage wurde genehmigt',
      FailureMessage: 'Fehler beim Genehmigen der Anfrage.',
      Title: 'Anfrage genehmigen?',
      OkText: 'Genehmigen',
      DescriptionText: `Möchten Sie diese Anfrage wirklich genehmigen?`
    },
    UploadCommentModal: {
      ViewAndAddComments: 'Kommentare anzeigen und hinzufügen',
      Content: 'Inhalt',
      DeleteButton: 'Löschen Taste',
      Time: 'Zeit',
      ErrorAddingComment: 'Fehler beim Hinzufügen des Kommentars',
      CommentAdded: 'Kommentar hinzugefügt',
      EnterYourCommentHere: 'Geben Sie hier Ihren Kommentar ein',
      AddComment: 'Kommentar hinzufügen',
      CommentsAdded: 'Kommentare hinzugefügt',
      Delete: 'Löschen'
    },
    DeleteCommentModal: {
      CommentDeleted: 'Kommentar gelöscht',
      ErrorDeletingComment: 'Fehler beim Löschen des Kommentars',
      DeleteComment: 'Kommentar löschen?',
      Delete: 'Löschen',
      DescriptionFirstLine: `Möchten Sie Ihren Kommentar wirklich löschen?`,
      DescriptionSecondLine: `Diese Aktion kann nicht rückgängig gemacht werden.`
    }
  },
  [CustomerListPageKey]: {
    PendingRequests: 'Ausstehende Anfragen',
    Customers: 'Kunden',
    CustomersList: 'Kundenliste',
    Upload: 'Hochladen',
    TransactionRequests: 'Transaktionsanfragen',
    DeactivatingCustomer: 'Kunde Wird Deaktiviert...',
    DeactivationRequestSubmitted: 'Kundendeaktivierungsanfrage Zur Genehmigung Eingereicht!',
    SuccessfullyDeactivated: 'Erfolgreich Deaktiviert!',
    DeactivationFailed: 'Deaktivierung Fehlgeschlagen',
    SuccessfullyDeleted: 'Erfolgreich Gelöscht!',
    DeletingCustomer: 'Kunde Wird Gelöscht...',
    ActivatingCustomer: 'Kunde Wird Aktiviert...',
    ActivationRequestSubmitted: 'Kundenaktivierungsanfrage Zur Genehmigung Eingereicht!',
    SuccessfullyActivated: 'Erfolgreich Aktiviert!',
    ActivationFailed: 'Aktivierung Fehlgeschlagen',
    LoadingCustomer: 'Kunde Wird Geladen...',
    ErrorRetrievingCustomer: 'Etwas Ist Schiefgelaufen!'
  },
  [CustomerDeactivationModalKey]: {
    ProvideReasonForDeactivation: 'Grund für Deaktivierung angeben',
    ProvideReasonForActivation: 'Grund für Aktivierung angeben',
    Deactivate: 'Deaktivieren',
    Activate: 'Aktivieren',
    Cancel: 'Abbrechen',
    DeactivationReason: 'Bitte Grund auswählen'
  },
  [CustomerDetailsKey]: {
    ID: 'ID',
    CustomerDetails: 'Kundendetails',
    RewardsLabel: 'Vergütung',
    Identifier: 'Kennung',
    UserInfo: 'Benutzerinformationen',
    FirstName: 'Vorname',
    MiddleName: 'Zweiter Vorname',
    LastName: 'Nachname',
    Gender: 'Geschlecht',
    Address: 'Adresse',
    Birthday: 'Geburtstag',
    JoinedAt: 'Beigetreten am',
    CreatedVia: 'Erstellt über',
    ReferralCode: 'Empfehlungscode',
    Email: 'E-Mail',
    Phone: 'Telefon',
    State: 'Bundesland',
    City: 'Stadt',
    Race: 'Rasse',
    Segment: 'Segment',
    AccountId: 'Konto-ID',
    Nationality: 'Nationalität',
    AlternateId: 'Alternative ID',
    ProductType: 'Produkttyp',
    Classification: 'Klassifikation',
    LocationState: 'Standort Bundesland',
    PreferredLanguage: 'Bevorzugte Sprache',
    FindRewardByNameTypeOrMerchant: 'Vergütung nach Name, Typ oder Händler finden',
    IssueRewards: 'Vergütungen ausstellen',

    RewardIssueMakerCheckerErrorMessage: 'Sie können Ihre eigene Anfrage nicht genehmigen',
    RewardIssueErrorMessage: 'Beim Ausgeben der Prämien ist ein Fehler aufgetreten',
    RewardIssueErrorsOccurredWhileIssuingRewards:
      'Bei der Vergabe der Prämien sind Fehler aufgetreten',
    RewardIssueSuccessMessage: 'Belohnung erfolgreich ausgestellt',
    RewardIssueMakerCheckerSuccessMessage: 'Antrag auf Prämienausgabe zur Genehmigung eingereicht',
    RewardIssueUnexpectedResponseFormat: 'Unerwartetes Antwortformat',
    Stamps: 'Stempelkarten',
    Games: 'Spiele',
    ProgressCampaign: 'Fortschrittskampagne',
    Company: 'Unternehmen',
    EmailTags: 'E-Mail-Tags',
    BusinessType: 'Geschäftstyp',
    INACTIVE: 'INAKTIV',
    Cashback: 'Cashback',

    ErrorRetrievingCustomer: 'Fehler beim Abrufen des Kunden',
    CustomerRewards: 'Kundenbelohnungen',
    LoyaltyProgram: 'Bonusprogramm',
    AccountDetails: 'Kontodetails',
    Campaigns: 'Kampagnen',
    EventLogs: {
      TabLabel: 'Ereignisprotokolle',
      Filters: {
        EventName: 'Ereignisname',
        EventNamePlaceholder: 'Ereignisnamen auswählen',
        Helper: 'Liste nach Ereignisnamen filtern'
      },
      Table: {
        ID: 'ID',
        EventName: 'Ereignisname',
        Params: 'Parameter',
        State: 'Status',
        CreatedAt: 'Erstellt am'
      },
      Detail: {
        Title: 'Details zum Ereignisprotokoll',
        Back: 'Zurück zu den Ereignisprotokollen',
        RuleOutcomes: 'Regelergebnisse',
        Error: 'Details zum Ereignisprotokoll konnten nicht geladen werden.',
        NoData: 'Ereignisprotokoll nicht gefunden.',
        Fields: {
          ID: 'ID',
          EventName: 'Ereignisname',
          State: 'Status',
          EventParams: 'Ereignisparameter',
          CreatedAt: 'Erstellt am',
          UpdatedAt: 'Aktualisiert am',
          ProcessingStartedAt: 'Verarbeitung gestartet am',
          ProcessingCompletedAt: 'Verarbeitung abgeschlossen am'
        }
      }
    },
    Transactions: {
      TabLabel: 'Transaktionen',
      Filters: {
        State: 'Status',
        StatePlaceholder: 'Status auswählen',
        TransactionReference: 'Transaktionsreferenz',
        TransactionReferencePlaceholder: 'Transaktionsreferenz eingeben',
        CreatedAtRange: 'Erstellungszeitraum',
        CreatedAtRangeStartPlaceholder: 'Startdatum',
        CreatedAtRangeEndPlaceholder: 'Enddatum',
        Helper: 'Liste nach Status, Referenz oder Erstellungsdatum filtern'
      },
      Table: {
        ID: 'ID',
        Reference: 'Referenz',
        Amount: 'Betrag',
        Properties: 'Eigenschaften',
        State: 'Status',
        CreatedAt: 'Erstellt am'
      },
      Detail: {
        Title: 'Transaktionsdetails',
        Back: 'Zurück zu den Transaktionen',
        Error: 'Transaktionsdetails konnten nicht geladen werden.',
        NoData: 'Transaktion nicht gefunden.',
        RuleOutcomes: 'Regelergebnisse',
        Fields: {
          ID: 'ID',
          Reference: 'Referenz',
          Amount: 'Betrag',
          State: 'Status',
          CreatedAt: 'Erstellt am',
          UpdatedAt: 'Aktualisiert am',
          TransactionDate: 'Transaktionsdatum',
          TransactionType: 'Transaktionstyp',
          Currency: 'Währung',
          ProcessedAt: 'Verarbeitet am',
          ProcessAt: 'Verarbeitung geplant am',
          TransactionStatus: 'Transaktionsstatus',
          UniqueTransactionId: 'Eindeutige Transaktions-ID',
          UserAccountId: 'Benutzerkonto-ID',
          AmountPoint: 'Punktebetrag',
          MerchantUserAccountId: 'Händler-Benutzerkonto-ID',
          WorkflowId: 'Workflow-ID',
          Properties: 'Eigenschaften'
        }
      }
    },
    RuleOutcomesTable: {
      RuleOutcomeId: 'Regelergebnis-ID',
      TransactionRuleId: 'Transaktionsregel-ID',
      TransactionRuleName: 'Name der Transaktionsregel',
      State: 'Status',
      AdditionalInfo: 'Zusätzliche Informationen',
      Empty: 'Keine Regelergebnisse verfügbar.'
    },
    FilteringChecks: {
      TabLabel: 'Filterprüfungen',
      RewardTabLabel: 'Belohnungsfilter',
      CampaignTabLabel: 'Kampagnenfilter',
      HelperText:
        'Führen Sie eine Prüfung aus, um zu sehen, welche Filter für diesen Kunden bestehen oder fehlschlagen.',
      PassedFilters: 'Bestandene Filter',
      FailedFilters: 'Fehlgeschlagene Filter',
      NoPassedFilters: 'Keine bestandenen Filter',
      NoFailedFilters: 'Keine fehlgeschlagenen Filter',
      GenericError: 'Kunden-ID ist ungültig.',
      NotFoundError: '404 nicht gefunden',
      ToggleHide: 'Abschnitt ausblenden',
      ToggleShow: 'Abschnitt einblenden',
      Reward: {
        Title: 'Belohnungsfilter-Prüfung',
        Description:
          'Geben Sie eine Kunden-ID ein, um zu sehen, welche Filter diesen Kunden für die Belohnung ein- oder ausschließen.',
        Placeholder: 'Kunden-ID eingeben',
        InputLabel: 'Kunden-ID',
        Button: 'Kundenfilter prüfen',
        MissingIdError: 'Bitte geben Sie eine Kunden-ID ein'
      },
      Campaign: {
        Title: 'Kampagnenfilter-Prüfung',
        Description:
          'Geben Sie eine Kunden-ID ein, um zu sehen, welche Filter diesen Kunden für die Kampagne ein- oder ausschließen.',
        Placeholder: 'Kunden-ID eingeben',
        InputLabel: 'Kunden-ID',
        Button: 'Kundenfilter prüfen',
        MissingIdError: 'Bitte geben Sie eine Kunden-ID ein'
      }
    },
    CustomerIDNotFound: 'Kunden-ID nicht gefunden',
    DeleteUser: 'Benutzer löschen',
    Activate: 'Aktivieren',
    Deactivate: 'Deaktivieren',
    ACTIVE: 'AKTIV',
    Inactive: 'Inaktiv',
    DeactivationReason: 'Deaktivierungsgrund',
    AddressState: 'Adressen-Bundesland',
    AddressCity: 'Adressen-Stadt',

    Name: 'Name',
    Status: 'Status',
    Tenure: 'Amtszeit',
    Tier: 'Stufe',
    Balance: 'Guthaben',
    ToNextTier: 'Zur nächsten Stufe',
    MembershipExpiry: 'Mitgliedschaftsablauf',

    CashbackModal: {
      CancelIssuanceModal: {
        Title: 'Ausgabeanfrage für Cashback stornieren?',
        MessageLineOne:
          'Die Ausgabeanfrage wartet auf Genehmigung. Sind Sie sicher, dass Sie sie stornieren möchten?'
      },
      ApproveIssuanceModal: {
        Title: 'Cashback-Ausgabe genehmigen',
        MessageLineOne:
          'Sind Sie sicher, dass Sie diese Cashback-Ausgabe genehmigen möchten? Diese Aktion kann nicht rückgängig gemacht werden.'
      }
    },

    Rewards: {
      FindRewardByNameTypeOrMerchant: 'Vergütung nach Name, Typ oder Händler finden',
      IssueRewardsManually: 'Vergütungen manuell ausstellen',
      Issued: 'Ausgestellt',
      Pending: 'Ausstehend',
      GiftedAway: 'Verschenkt',
      Redeemed: 'Eingelöst',
      RedemptionInProgress: 'Einlösung in Bearbeitung',
      FullyRedeemed: 'Vollständig eingelöst',
      Voided: 'Ungültig gemacht',
      Expired: 'Abgelaufen',
      Archived: 'Archiviert',

      Name: 'Name',
      DeletionRequested: 'Löschung angefordert',
      ID: 'ID',
      Merchant: 'Händler',
      DateOfIssued: 'Ausstellungsdatum',
      ValidFrom: 'Gültig von',
      ValidTo: 'Gültig bis',
      VoucherCode: 'Gutscheincode',
      AdminFee: 'Verwaltungsgebühr',
      Action: 'Aktion',
      DateOfExpired: 'Ablaufdatum',
      DateOfGifted: 'Geschenkdatum',
      DateOfRedeemed: 'Einlösedatum',
      RequestId: 'Anfrage-ID',
      Status: 'Status',
      RewardId: 'Belohnungs-ID',
      IssuedOn: 'Ausgestellt am',

      RequestType: 'Anforderungsart',
      CancelVoidRequest: 'Void Anfrage abbrechen',
      CancelUpdateRequest: 'Aktualisierungsanforderung abbrechen',
      CancelIssueRequest: 'Problemanfrage stornieren',
      ErrorApprovingRewards: 'Fehler beim Genehmigen der Belohnungen.',

      VoidVoucher: 'Gutschein ungültig machen',
      ChangeExpiryDate: 'Ablaufdatum ändern',
      AmendReward: 'Belohnung ändern',
      UndoRedeem: 'Einlösung rückgängig machen',
      ThereIsNoActionForGiftedVoucher: 'Keine Aktion für verschenkten Gutschein.',
      RevertBackToIssued: 'Zu Ausgestellt zurückkehren',
      WaiveAdminFee: 'Verwaltungsgebühr erlassen',
      DeleteReward: 'Belohnung löschen',
      ViewComments: 'Kommentare anzeigen',
      ApproveIssue: 'Ausgabe genehmigen',

      ViewAndAddComments: 'Kommentare anzeigen und hinzufügen',
      RequestHasBeenApproved: 'Anfrage wurde genehmigt',
      SomethingWentWrong: 'Etwas ist schief gelaufen',
      HandleUndoRedeemErrorMessage:
        'Einlösung kann nicht rückgängig gemacht werden - bitte ändern Sie das Ablaufdatum und versuchen Sie es erneut.',
      HandleUndoRedeemConfirmModalTitle: 'Bestätigen',
      HandleUndoRedeemConfirmModalMessage:
        'Dies wird den Gutscheinzustand auf Ausgestellt zurücksetzen - fortfahren?',

      HandleVoidVoucherMakerCheckerSuccessMessage:
        'Ungültigmachungsantrag zur Genehmigung eingereicht',
      HandleVoidVoucherSuccessMessage: 'Gutschein ist ungültig gemacht',
      HandleVoidVoucherConfirmModalMakerCheckerRightButtonText: 'Ungültigmachung beantragen',
      HandleVoidVoucherConfirmModalRightButtonText: 'Bestätigen',
      HandleVoidVoucherConfirmModalMakerCheckerTitle: 'Ungültigmachungsantrag einreichen?',
      HandleVoidVoucherConfirmModalTitle: 'Bestätigen',
      HandleVoidVoucherConfirmModalMakerCheckerMessage:
        'Sind Sie sicher, dass Sie die Ungültigmachung des Belohnungsgutscheins beantragen möchten? Einmal genehmigt, können Sie ihn nicht wiederherstellen.',
      HandleVoidVoucherConfirmModalMessage:
        'Dies wird den Belohnungsgutschein ungültig machen - fortfahren?',

      HandleRevertRedemptionToIssuedConfirmModalTitle: 'Bestätigen',
      HandleRevertRedemptionToIssuedMessageConfirmModalMessage:
        'Dies wird den Gutscheinzustand auf Ausgestellt zurücksetzen - fortfahren?',

      ShowOCBCDemoConfirmModalTitle: 'Bestätigen',
      ShowOCBCDemoConfirmModalMessage: 'Dies wird die Verwaltungsgebühr erlassen - fortfahren?'
    },

    IssueRewardsModal: {
      Title: 'Vergütungen manuell ausstellen',
      OkText_one: '{{count}} Vergütung ausstellen',
      OkText_other: '{{count}} Vergütungen ausstellen',
      SearchPlaceholder: 'Vergütung nach Name, Typ oder Händler finden',
      ActiveTabLabel: 'Aktiv',
      PrivateTabLabel: 'Privat',
      CancelText: 'Stornieren',

      CustomerRewardsConfirmationModal: {
        RewardName: 'Vergütungsname',
        RewardPrices: 'Belohnungspreise',
        FreeOrPaid: 'Kostenlos/Bezahlt',
        ConfirmSellPrice: 'Verkaufspreis bestätigen',
        And: 'und',
        Points: 'Punkte',
        Or: 'ODER',
        Paid: 'Bezahlt',
        Free: 'Kostenlos',
        Cancel: 'Abbrechen',
        IssueRewards: 'VERGÜTUNG AUSGEBEN'
      }
    },
    IssueRewardsTable: {
      Name: 'Name',
      Merchant: 'Händler',
      ValidityPeriod: 'Gültigkeitszeitraum',
      Balance: 'Guthaben'
    },
    AuditLog: {
      Title: 'Audit-Protokoll',
      LastUpdatedAt: 'Zuletzt aktualisiert am',
      IpAddress: 'IP-Adresse',
      User: 'Benutzer',
      Action: 'Aktion',
      Description: 'Beschreibung',
      RenderSummaryIsCreated: 'erstellt',
      RenderSummaryIsUpdated: 'aktualisiert',
      Details: 'Details',
      Old: 'Alt',
      New: 'Neu',
      Audience: {
        Created: 'Audience created',
        NameUpdated: 'Audience name updated',
        FiltersUpdated: 'Filter customers updated',
        FileUploaded: 'Audience File uploaded',
        FileRemoved: 'Audience File removed',
        FileRelationChanged: 'Audience File relation changed',
        Uploaded: 'uploaded',
        Removed: 'removed',
        RelationChangedTo: 'relation changed to',
        NameLabel: 'Audience name',
        Criteria: {
          Age: 'Age',
          Gender: 'Gender',
          CustomAttributes: 'Custom Attributes'
        },
        AttributeGroup: 'Customer attributes',
        AttributeGroupRaw: 'Customer attributes (excluded group)'
      },
      DetailsColumn: {
        AutoFillStamps: 'Briefmarken automatisch ausfüllen',
        Wedges: 'Keile',
        LandingPage: 'Zielseite',
        EnrolmentType: 'Anmeldungsart',
        AutoEnrolUsers: 'Automatische Benutzeranmeldung',
        State: 'Status',
        NameEn: 'Name (EN)',
        Ordering: 'Sortierung',
        Timezone: 'Zeitzone',
        StartDate: 'Startdatum',
        AutoIssueMoves: 'Automatische Zugausgabe',
        TypeOfCampaign: 'Kampagnentyp',
        OutcomesPerMove: 'Ergebnisse pro Zug',
        TypeOfCampaignReferral: 'Kampagnen-Empfehlungstyp',
        Rewards: 'Belohnungen',
        PeriodUnits: 'Zeiteinheiten',
        RewardsOrdering: 'Belohnungssortierung',
        NoOfStampsPerColumn: 'Briefmarken pro Spalte',
        CampaignIntervalPeriod: 'Kampagnen-Intervall',
        DisplayPropertiesZhHans: 'Anzeige-Eigenschaften Zh Hans',
        DisplayPropertiesZhHant: 'Anzeige-Eigenschaften Zh Hant',

        Header: 'Header',
        CardImage: 'Kartenbild',
        ButtonText: 'Schaltflächentext',
        ThumbnailImage: 'Vorschaubild',
        ButtonBgColour: 'Schaltflächentextfarbe',
        GiftActiveImage: 'Geschenkbild aktiv',
        ButtonTextColour: 'Schaltflächentextfarbe',
        StampActiveImage: 'Briefmarke aktiv',
        DisplayCampaignAs: 'Kampagne als anzeigen',
        GiftInactiveImage: 'Geschenkbild inaktiv',
        ButtonExternalLink: 'Schaltflächentext-Link',
        StampInactiveImage: 'Briefmarke inaktiv',
        CardBackgroundImage: 'Kartenhintergrundbild',
        Cols: 'Spalten',
        Rows: 'Zeilen',
        Tags: 'Tags',
        Labels: 'Labels',
        Referee: 'Referee',
        Categories: 'Kategorien',
        DescriptionEn: 'Beschreibung EN',
        TermsAndConditionsEn: 'Nutzungsbedingungen EN',
        RefereeTotalRewardLimit: 'Referee-Gesamtguthabenlimit',
        ClaimPrize: 'Belohnung beanspruchen',
        StampsAwarded: 'Briefmarken vergeben',
        Status: 'Status',
        Value: 'Wert',
        Operators: 'Operatoren',
        RuleName: 'Regelname',
        Body: 'Körper',
        MilestonesSuccessImage: 'Milestone-Erfolgsbild',
        SelectRuleAttribute: 'Regelattribut auswählen',
        EndDate: 'Enddatum',
        GrandPrizeOutcome: 'Hauptgewinnausgang',
        RaffleTicketOutcome: 'Raffle-Ticketausgang',
        NoOfStampsPerRow: 'Briefmarken pro Zeile',
        TotalStampsOnCard: 'Briefmarken insgesamt'
      }
    },
    DeleteCustomerModal: {
      MakesCheckerErrorMessage:
        'Implementieren Sie die API -Integration mit Maker Checker unter Fortschritt',
      Title: 'Benutzer löschen?',
      OkText: 'bestätigen',
      CancelText: 'Zurückgehen',
      DescriptionLineOne: 'Möchten Sie diesen Benutzer wirklich löschen?',
      DescriptionLineTwo: 'Diese Aktion kann nicht rückgängig gemacht werden.',
      Name: 'Name:',
      Identifier: 'Kennung:'
    },

    LoyaltyProgramsTable: {
      Name: 'Name',
      Status: 'Status',
      Tenure: 'Amtszeit',
      Tier: 'Stufe',
      Balance: 'Guthaben',
      ToNextTier: 'Zur nächsten Stufe',
      MembershipExpiry: 'Mitgliedschaftsablauf',
      Actions: 'Aktionen'
    },
    LoyaltyProgramDetailsModal: {
      Title: 'Bonusprogramm Details',
      CloseButton: 'SCHLIESSEN',
      Active: 'Aktiv',
      Pending: 'Ausstehend',
      Actions: 'Aktionen',
      ActionCancelRequest: 'Anfrage stornieren',
      ActionApproveIssue: 'Ausgabe genehmigen',
      ActionApproveDeletion: 'Löschung genehmigen',
      ActionDenyDeletion: 'Löschung ablehnen',
      ActionComments: 'Kommentare',
      ActionCommentsModalTitle: 'Kommentare anzeigen und hinzufügen',

      CancelIssuance: 'Ausstellung stornieren',
      CancelDeletion: 'Löschung abbrechen',

      Event: 'Ereignis',
      EventButton: 'Löschung angefordert',
      Carryforward: 'Übertrag',
      Status: 'Status',
      SubmissionDate: 'Einreichungsdatum',
      Points: 'Punkte',
      ExpiresAt: 'Läuft ab am',
      TransactionId: 'Transaktions-ID',
      LoyaltyTransactionId: 'Treuetransaktions-ID',
      AmountTransacted: 'Transaktionsbetrag',
      TransactionAmount: 'Transaktionsbetrag',
      TransactionDate: 'Transaktionsdatum',
      Date: 'Datum',
      TransactionRef: 'Transaktionsreferenz',
      AwardingTransactionId: 'Vergabe-Transaktions-ID',
      Properties: 'Eigenschaften',
      Merchant: 'Händler',
      GlAccountNumber: 'GL-Kontonummer',
      CostCenterId: 'Kostenstellen-ID',
      BranchCode: 'Filialcode',

      ChangeStatus: 'Status ändern',
      ChangeTier: 'Stufe ändern',
      AddOrRemovePoints: 'Punkte hinzufügen / entfernen',
      AmountIsRequired: 'Betrag Ist Erforderlich',
      AmountMustBeNonZero: 'Betrag Darf Nicht Null Sein',

      PointsAwarded: 'Punkte Vergeben',

      ChangeStatusForm: {
        Active: 'Aktiv',
        Inactive: 'Inaktiv',
        Save: 'Speichern'
      },
      ChangeTierForm: {
        Label: 'Stufe überschreiben läuft ab am:',
        Save: 'Speichern'
      },
      PointsForm: {
        SelectGlAccount: 'GL-Konto auswählen',
        GlAccountType: 'GL-Kontotyp',
        GlAccountName: 'GL-Kontoname',
        Message: 'Schreiben Sie eine Nachricht zu dieser Punkteanpassung.',
        AdjustPointsButton: 'Punkte anpassen',
        GLAccountIdIsRequired: 'GL-Konto-ID Ist Erforderlich',
        GLAccountTypeIsRequired: 'GL-Kontotyp Ist Erforderlich',
        GLAccountNameIsRequired: 'GL-Kontoname Ist Erforderlich'
      },
      UpdateLoyaltyProgramCustomerStateSuccessMessage: 'Status aktualisiert',
      UpdateLoyaltyProgramCustomerStateErrorMessage: 'etwas ist schief gelaufen',
      UpdateLoyaltyProgramCustomerTierSuccessMessage: 'Stufe aktualisiert',
      UpdateLoyaltyProgramCustomerTierErrorMessage: 'etwas ist schief gelaufen',
      CreateCustomerLoyaltyTransaction: {
        GLAccountTypeRequiredMessage: 'GL-Kontotyp ist erforderlich',
        GlAccountNameRequiredMessage: 'GL-Kontoname ist erforderlich',
        MakerCheckerSuccessMessage: 'Punktausgabe-Antrag zur Genehmigung eingereicht',
        SuccessMessage: 'Transaktion hinzugefügt',
        ErrorMessage: 'etwas ist schief gelaufen'
      },
      DeleteCustomerRequestLoyaltyTransaction: {
        SuccessMessage: 'Anfrage wurde storniert',
        ErrorMessage: 'etwas ist schief gelaufen'
      },
      ApproveDenyCustomerRequestLoyaltyTransaction: {
        ApproveSuccessMessage: 'Anfrage wurde ',
        RequestHasBeenDeletedMessage: 'Anfrage wurde gelöscht',
        RequestHasBeenApprovedMessage: 'Antrag wurde genehmigt',
        ErrorMessage: 'etwas ist schief gelaufen'
      },
      DeleteCustomerLoyaltyTransaction: {
        MakerCheckerSuccessMessage: 'Transaktionslöschungsantrag zur Genehmigung eingereicht',
        SuccessMessage: 'Transaktion gelöscht',
        ErrorMessage: 'etwas ist schief gelaufen'
      },
      RecoverCustomerLoyaltyTransaction: {
        SuccessMessage: 'Transaktion wiederhergestellt',
        ErrorMessage: 'etwas ist schief gelaufen'
      },
      DeleteCustomerLoyaltyTransactionModal: {
        ActiveTitle: 'Löschungsantrag einreichen?',
        ActiveOkText: 'Löschung beantragen',
        ActiveCancelText: 'Abbrechen',
        CancelText: 'Zurück',
        ActiveMessage:
          'Sind Sie sicher, dass Sie die Löschung dieser Punkte beantragen möchten? Einmal genehmigt, können Sie sie nicht wiederherstellen.',
        MessageLineOne: `Die Ausgabe dieser Punkte steht noch zur Genehmigung aus. Möchten Sie die Anfrage wirklich stornieren?`,
        MessageLineTwo: 'Diese Aktion kann nicht rückgängig gemacht werden.',

        CancelDeletionTitle: 'Punkte Löschung abbrechen?',
        Title: 'Antrag auf Ausstellung von Punkten stornieren?',
        OkText: 'Bestätigen',
        MessageLineOneDeletion: 'Die Löschung dieser Punkte ist die Genehmigung aus. '
      },
      ApproveDenyModal: {
        DenyDeletionOkText: 'Ablehnen',
        OkText: 'Genehmigen',
        ApproveIssueTitle: 'Problem mit Treuepunkten genehmigen',
        ApproveDeletionTitle: 'Genehmigen Sie die Löschung von Treuepunkten',
        DenyDeletionTitle: 'Anfrage zum Löschen von Treuepunkten ablehnen',
        ApproveIssueAndDeletionMessageLineOne: 'Sind Sie sicher, dass Sie dies genehmigen möchten?',
        ApproveIssueAndDeletionMessageLineTwo: 'von Loyalitätspunkten? ',
        Message: 'Sind Sie sicher, dass Sie die Löschung dieser Treuepunkte leugnen möchten? ',
        Issuance: 'Ausgabe',
        Deletion: 'Streichung'
      },

      LineProgressBar: {
        HeaderDateText: 'Beginn des Zeitraums',
        CustomerTierText: 'Der Benutzer befindet sich derzeit in',
        Tier: 'Stufe',
        CustomerForcedMinimumTierText: 'Der Benutzer wurde in die Mindeststufe gezwungen',
        CustomerForcedMaximumTierText: `Der Benutzer wurde `,
        FORCED: 'GEZWUNGEN',
        into: 'in',
        EndOfPeriod: 'Ende des Zeitraums',
        ForcedTier: 'Erzwungene Stufe',
        ForcedMinTier: 'Erzwungene Mindeststufe',
        UserHasBeen: 'Benutzer wurde',
        Forced: 'gezwungen',
        To: 'zu',
        Status: 'Status',
        Until: 'bis',
        DeleteForcedTierLinkText: 'X Erzwungene Stufe deaktivieren',
        ToMinimum: 'auf Minimum',
        TheUserHasEarned: 'Der Benutzer hat verdient',
        Points: 'Punkt(e)',
        DuringThisCycle: 'während dieses Zyklus.',
        TheUserRequires: 'Der Benutzer benötigt',
        ToLevelUpTo: 'um aufzusteigen zu',
        TheUserHas: 'Der Benutzer hat',
        Available: 'verfügbar.'
      }
    },

    CashbackTable: {
      CashbackTransactionID: 'Cashback Transaktion ID',
      Event: 'Ereignis',
      CashbackAmount: 'Cashback Betrag',
      Currency: 'Währung',
      Date: 'Datum',
      CashbackRuleID: 'Cashback Regel ID',
      TransactionID: 'Transaktions ID',
      TransactionAmount: 'Transaktions Betrag',
      LoyaltyProgramID: 'Loyalty Programm ID',
      Points: 'Punkte',
      IssueCashback: 'Cashback ausstellen',
      AvailablePoints: 'Verfügbare Punkte',
      NoOfPointsToRedeem: 'Anzahl der einzulösenden Punkte',
      Back: 'Zurück',
      InsufficientPoints: 'Unzureichende Punkte',
      CashbackMaxError: 'Kann nicht mehr als',
      CashbackRuleIDIsRequired: 'Cashback Regel ID ist erforderlich',
      LoyaltyProgramIDIsRequired: 'Loyalty Programm ID ist erforderlich',
      PointsAreRequired: 'Punkte sind erforderlich',
      PointsMustBeANumber: 'Punkte müssen eine Zahl sein',
      PointsMustBeAnInteger: 'Punkte müssen eine ganze Zahl sein',
      CashbackIssuedSuccessfully: 'Cashback erfolgreich ausgestellt',
      IssueCashbackRequestSubmittedSuccessfully:
        'Anfrage zur Ausstellung von Cashback wurde erfolgreich eingereicht.'
    },

    CustomerCampaigns: {
      ID: 'ID',
      HitThePinata: 'Auf die Piñata schlagen',
      ScratchCard: 'Rubbellos',
      Plinko: 'Plinko',
      Name: 'Name',
      CampaignType: 'Kampagnentyp',
      Status: 'Status',
      StartDate: 'Startdatum',
      EndDate: 'Enddatum',
      Actions: 'Aktionen',
      SearchCampaignsPlaceholder: 'Kampagnen suchen',
      UnenrollCustomer: 'Kunden abmelden',
      NotStarted: 'Nicht gestartet',
      Active: 'Aktiv',
      Completed: 'Abgeschlossen',
      NotCompleted: 'Nicht abgeschlossen',
      Enrollable: 'Einschreibbar',
      EndedAndNotEnrolled: 'Beendet und nicht eingeschrieben',
      Enrolled: 'Eingeschrieben',
      NotEnrolled: 'Nicht eingeschrieben',
      SpinTheWheel: 'Drehen Sie das Rad',
      ShakeTheTree: 'Den Baum schütteln',
      EnrollCustomer: 'Kunden einschreiben',
      SelectCampaignsPlaceholder: 'Kampagnen auswählen',
      EnrollUserSuccessMessage: 'Kampagne eingeschrieben',
      UnenrollUserSuccessMessage: 'Kampagne abgemeldet',
      SomethingWentWrong: 'Etwas ist schief gelaufen',
      AddOrRemovePointsButton: 'Punkte hinzufügen/entfernen',

      SelectedTypeCampaigns: {
        Customers: 'Kunden',
        Campaigns: 'Kampagnen',
        StampCampaign: 'Stempelkampagne',
        QuizCampaign: 'Quizkampagne',
        SurveyCampaign: 'Umfragekampagne',
        GameCampaign: 'Spielkampagne',
        ProgressCampaign: 'Fortschrittskampagne',
        QuestCampaign: 'Questkampagne',
        InstantRewardCampaign: 'Sofortbelohnungskampagne',
        StreakCampaign: 'Streak-Kampagne',
        CampaignProgress: 'Dieser Kunde befindet sich derzeit in'
      },

      RaffleView: {
        TriggerName: 'Auslösername',
        RaffleRuleID: 'Raffleregel-ID',
        TransactionDetails: 'Transaktionsdetails',
        TransactionRuleID: 'Transaktionsregel-ID',
        TriggeredDateOrTime: 'Ausgelöstes Datum',
        RaffleCode: 'Rafflec-Code',
        State: 'Status',
        Reversed: 'Storniert',
        ReversalReason: 'Stornierungsgrund',
        ReversedAt: 'Storniert am',
        ReversedBy: 'Storniert von',
        System: 'System'
      },

      InstantRewardView: {
        TriggerName: 'Auslösername',
        RuleID: 'Regel-ID',
        TransactionDetails: 'Transaktionsdetails',
        TriggeredDateOrTime: 'Abgeschlossenes Datum',
        Ref: 'Ref'
      },

      QuestView: {
        TriggerName: 'Auslösername',
        Task: 'Aufgabe',
        QuestRuleID: 'Quest-Regel-ID',
        TransactionDetails: 'Transaktionsdetails',
        TransactionRuleID: 'Transaktionsregel-ID',
        TriggeredDateOrTime: 'Ausgelöstes Datum / Uhrzeit',
        State: 'Status',
        Actions: 'Aktionen',
        MarkCompleted: 'Als abgeschlossen markieren',
        MarkCompletedSuccessMessage: 'Punkte erfolgreich aktualisiert!',
        MarkCompletedErrorMessage: 'Fehler beim Aktualisieren der Punkte'
      },

      CustomerProgressCard: {
        TriggerName: 'Auslösername',
        ProgressRuleID: 'Fortschrittsregel-ID',
        TransactionDetails: 'Transaktionsdetails',
        TransactionRuleID: 'Transaktionsregel-ID',
        TriggeredDateOrTime: 'Ausgelöstes Datum / Uhrzeit',
        Points: 'Punkte',
        STAGE: 'STUFE',
        ThisCustomerIsCurrentlyOn: 'Dieser Kunde befindet sich derzeit in',
        FIRST: 'ERSTE',
        SECOND: 'ZWEITE',
        THIRD: 'DRITTE',
        FOURTH: 'VIERTE',
        FIFTH: 'FÜNFTE',
        SIXTH: 'SECHSTE',
        SEVENTH: 'SIEBTE',
        EIGHTH: 'ACHTE',
        NINTH: 'NEUNTE',
        TENTH: 'ZEHNTE',
        ELEVENTH: 'ELFTE',
        TWELFTH: 'ZWÖLFTE',
        THIRTEENTH: 'DREIZEHNTE',
        FOURTEENTH: 'VIERZEHNTE',
        FIFTEENTH: 'FÜNFZEHNTE',
        SIXTEENTH: 'SECHSZEHNTE',
        SEVENTEENTH: 'SIEBZEHNTE',
        EIGHTEENTH: 'ACHTZEHNTE',
        NINETEENTH: 'NEUNZEHNTE',
        TWENTIETH: 'ZWANZIGSTE',
        TWENTYFIRST: 'EINUNDZWANZIGSTE',
        TWENTYSECOND: 'ZWEIUNDZWANZIGSTE',
        TWENTYTHIRD: 'DREIUNDZWANZIGSTE',
        TWENTYFOURTH: 'VIERUNDZWANZIGSTE',
        TWENTYFIFTH: 'FÜNFUNDZWANZIGSTE',
        TWENTYSIXTH: 'SECHSUNDZWANZIGSTE',
        TWENTYSEVENTH: 'SIEBENUNDZWANZIGSTE',
        TWENTYEIGHTH: 'ACHTUNDZWANZIGSTE',
        TWENTYNINTH: 'NEUNUNDZWANZIGSTE',
        THIRTITH: 'DREISSIGSTE',
        THIRTYFIRST: 'EINUNDREIßIGSTE',
        THIRTYSECOND: 'ZWEIUNDREIßIGSTE',
        THIRTYTHIRD: 'DREIUNDREIßIGSTE',
        THIRTYFOURTH: 'VIERUNDREIßIGSTE',
        THIRTYFIFTH: 'FÜNFUNDREIßIGSTE',
        THIRTYSIXTH: 'SECHSUNDREIßIGSTE',
        THIRTYSEVENTH: 'SIEBENUNDREIßIGSTE',
        THIRTYEIGHTH: 'ACHTUNDREIßIGSTE',
        THIRTYNINTH: 'NEUNUNDREIßIGSTE',
        FORTIETH: 'VIERZIGSTE',
        FORTYFIRST: 'EINUNDVIERZIGSTE',
        FORTYSECOND: 'ZWEIUNDVIERZIGSTE',
        FORTYTHIRD: 'DREIUNDVIERZIGSTE',
        FORTYFOURTH: 'VIERUNDVIERZIGSTE',
        FORTYFIFTH: 'FÜNFUNDVIERZIGSTE',
        FORTYSIXTH: 'SECHSUNDVIERZIGSTE',
        FORTYSEVENTH: 'SIEBENUNDVIERZIGSTE',
        FORTYEIGHTH: 'ACHTUNDVIERZIGSTE',
        FORTYNINTH: 'NEUNUNDVIERZIGSTE',
        FIFTIETH: 'FÜNFZIGSTE'
      },

      CustomerGameView: {
        TriesID: 'Versuche-ID',
        Status: 'Status',
        AcquiredVia: 'Erworben über',
        ReasonCode: 'Begründungscode',
        Email: 'E-Mail',
        ID: 'ID',
        DateOfIssue: 'Ausstellungsdatum',
        DateOfExpiry: 'Ablaufdatum',
        Outcomes: 'Ergebnisse',
        VoucherID: 'Gutschein-ID',
        NoOutcome: 'kein Ergebnis',
        NoExpiry: 'Kein Ablauf',

        SorrySomethingWentWrong: 'Entschuldigung, etwas ist schief gelaufen!',
        All: 'Alle',
        Issued: 'Ausgegeben',
        Redeem: 'Tilgen',
        Expired: 'Abgelaufen',
        Pending: 'Ausstehend',
        CustomerSupport: 'Kundensupport',
        PendingColumns: {
          RequestID: 'Anfrage ID',
          Status: 'Status',
          Reason: 'Grund',
          NumberOfTries: 'Anzahl der Versuche',
          DateOfRequest: 'Datum der Anfrage',
          Actions: 'Aktionen'
        },
        ApproveIssue: 'Ausgabe genehmigen',
        ViewComments: 'Kommentare anzeigen',
        ViewAndAddComments: 'Kommentare anzeigen und hinzufügen',
        ApproveIssueSuccessMessage: 'Anfrage wurde genehmigt',
        ApproveIssueErrorMessage: 'Etwas lief schief',
        ApproveDenyModal: {
          Title: 'Genehmigen Sie Belohnungsausgaben',
          OkText: 'Genehmigen',
          CancelText: 'Stornieren',
          Description: 'Sind Sie sicher, dass Sie der Ausgabe dieser Belohnung zustimmen möchten? '
        },
        CustomerCardView: {
          Slot: 'Slot #',
          StampId: 'Briefmarken -ID',
          Status: 'Status',
          AcquiredVia: 'Über erworben über',
          StampIssuedDate: 'Ausstellungsdatum des Stempels',
          StampRedeemedDate: 'Stempel Erlöste Datum',
          Outcomes: 'Ergebnisse',
          RedeemTheStamp: 'Lösen Sie den Stempel ein',
          EmptySlots: 'Leere Slots',
          SlotEmpty: 'Steckplatz leer',
          ID: 'AUSWEIS',
          VoucherID: 'Gutschein -ID',
          RewardID: 'Belohnung ID',
          NoRewards: 'Keine Belohnungen ausgestellt',
          NoRewardsIssued: 'Keine Prämien ausgegeben',
          Note: 'Notiz',
          Email: 'E-Mail',
          SorrySomethingWentWrong: 'Entschuldigung, etwas ist schief gelaufen'
        }
      },

      CustomerQuizAndSurveyView: {
        QuestionNo: 'Fragen-Nr.',
        Question: 'Frage',
        Response: 'Antwort',
        SubmissionDateOrTime: 'Einreichungsdatum / -uhrzeit',
        Result: 'Ergebnis'
      },

      IssueGameChangeModal: {
        MakerCheckerSuccessMessage: 'Spielchance-Ausgabeantrag zur Genehmigung eingereicht',
        SuccessMessage: 'Spielchancen erfolgreich ausgestellt!',
        ErrorMessage: 'Fehler beim Ausstellen der Spielchancen',
        IssueGameTriesButton: 'Spielversuche ausstellen',
        Title: 'Spielchance ausstellen an',
        OkText: 'Chance ausstellen',
        HowManyChances: 'Wie viele Chancen?',
        IssueGameChanceButton: 'Spielchance ausgeben',
        ReasonForIssuance: 'Grund zur Ausgabe',
        ChanceCountValidationMessage: 'Bitte geben Sie eine Anzahl der Chancen an.',
        ReasonForIssuanceValidationMessage: 'Bitte geben Sie einen Ausstellungsgrund an.'
      },

      CustomerStampCards: {
        CardHash: 'Karte #',
        StampCardID: 'Stempelkarte-ID',
        State: 'Status',
        ExpiryDate: 'Ablaufdatum',
        DateOfParticipation: 'Teilnahmedatum',
        StampsCollected: 'Gesammelte Stempel',
        CompletedDate: 'Abschlussdatum',
        RewardsAchieved: 'Erreichte Belohnungen',

        PendingColumns: {
          RequestID: 'Anfrage ID',
          State: 'Zustand',
          Reason: 'Grund',
          NumberOfStamps: 'Anzahl Briefmarken',
          DateOfRequest: 'Datum der Anfrage',
          Actions: 'Aktionen'
        },
        CancelIssuance: 'Ausstellung stornieren',
        ApproveIssue: 'Ausgabe genehmigen',
        ApproveIssueSuccessMessage: 'Anfrage wurde genehmigt',
        ApproveIssueErrorMessage: 'Etwas ist schief gelaufen',
        ViewComments: 'Kommentare anzeigen',
        Active: 'Aktiv',
        Expired: 'Abgelaufen',
        Completed: 'Abgeschlossen',
        Pending: 'Ausstehend',
        SorrySomethingWentWrong: 'Entschuldigung, etwas ist schief gelaufen'
      },

      IssueStampsModal: {
        MakerCheckerSuccessMessage: 'Stempelausgabeantrag zur Genehmigung eingereicht',
        SuccessMessage: 'Stempel erfolgreich ausgestellt!',
        IssueStampsButton: 'Stempel ausstellen',
        Title: 'Stempel ausstellen an',
        OkText: 'Stempel ausstellen',
        HowManyStamps: 'Wie viele Stempel?',

        ErrorMessage: 'Fehler beim Ausstellen der Stempel',
        CancelText: 'Stornieren',
        ReasonForIssuance: 'Grund zur Ausgabe',
        CustomerFullNameDefault: 'Aktueller Kunde',
        StampsCountValidationMessage: 'Bitte geben Sie eine Anzahl der Briefmarken an.',
        ReasonToIssuanceValidationMessage: 'Bitte geben Sie einen Ausstellungsgrund an'
      },

      DeleteRequestModal: {
        SuccessMessage: 'Die Anfrage wurde storniert',
        ErrorMessage: 'Etwas lief schief',
        Title: 'Stornieren {{type}} Ausstellungsantrag?',
        OkText: 'Bestätigen',
        CancelText: 'Stornieren',
        DescriptionLineOne: 'Das {{lowerCaseType}} ist ausstehend Zustimmung. ',
        DescriptionLineTwo:
          'Sobald die Stornierung genehmigt wurde, ist dies {{lowerCaseType}} nicht verfügbar und Sie müssen es erneut erstellen.'
      },

      IssueRewardModal: {
        RewardIssuedSuccessfully: 'Belohnung erfolgreich ausgestellt!',
        ErrorIssueReward: 'Fehler bei der Belohnungsausgabe',
        IssueRewardTitle: 'Belohnungen ausstellen',
        IssueRewardOkText: 'Belohnung ausstellen',
        IssueRewardButton: 'Belohnung ausstellen',
        ReasonForAdjustment: 'Grund für die Anpassung',
        PleaseSpecifyAReasonForAdjustment: 'Bitte Geben Sie Einen Grund Für Die Anpassung An'
      },

      ProgressPointsPendingView: {
        RequestID: 'Anfrage-ID',
        Status: 'Status',
        Reason: 'Grund',
        NumberOfPoints: 'Anzahl der Punkte',
        DateOfRequest: 'Datum der Anfrage',
        Actions: 'Aktionen',
        ApproveRequest: 'Anfrage genehmigen',
        CancelIssuance: 'Ausgabe stornieren',
        ViewComments: 'Kommentare anzeigen',
        ViewAndAddComments: 'Kommentare anzeigen und hinzufügen',
        ApproveRequestSuccessMessage: 'Anfrage wurde genehmigt',
        ApproveRequestErrorMessage: 'Etwas ist schiefgelaufen',
        Pending: 'Ausstehend',
        Completed: 'Abgeschlossen',
        All: 'Alle',
        ApproveDenyModal: {
          Title: 'Fortschrittspunkte-Ausgabe genehmigen',
          OkText: 'Genehmigen',
          CancelText: 'Abbrechen',
          Description:
            'Sind Sie sicher, dass Sie diese Fortschrittspunkte-Ausgabe genehmigen möchten? Diese Aktion kann nicht rückgängig gemacht werden.'
        }
      },

      QuestTaskPendingView: {
        RequestID: 'Anfrage-ID',
        Status: 'Status',
        Task: 'Aufgabe',
        Reason: 'Grund',
        DateOfRequest: 'Datum der Anfrage',
        Actions: 'Aktionen',
        ApproveRequest: 'Anfrage genehmigen',
        CancelIssuance: 'Ausgabe stornieren',
        ViewComments: 'Kommentare anzeigen',
        ViewAndAddComments: 'Kommentare anzeigen und hinzufügen',
        ApproveRequestSuccessMessage: 'Anfrage wurde genehmigt',
        ApproveRequestErrorMessage: 'Etwas ist schiefgelaufen',
        Pending: 'Ausstehend',
        Completed: 'Abgeschlossen',
        All: 'Alle',
        ReasonForCompletion: 'Grund für den Abschluss',
        ReasonRequired: 'Bitte geben Sie einen Grund an',
        ReasonModalTitle: 'Quest-Aufgabe als erledigt markieren',
        ReasonModalOkText: 'Absenden',
        RequestSubmittedForApproval: 'Anfrage zur Genehmigung eingereicht',
        ApproveDenyModal: {
          Title: 'Quest-Aufgabe-Abschluss genehmigen',
          OkText: 'Genehmigen',
          CancelText: 'Abbrechen',
          Description:
            'Sind Sie sicher, dass Sie diesen Quest-Aufgabe-Abschluss genehmigen möchten? Diese Aktion kann nicht rückgängig gemacht werden.'
        }
      },

      InstantRewardPendingView: {
        RequestID: 'Anfrage-ID',
        Status: 'Zustand',
        Reason: 'Grund',
        DateOfRequest: 'Datum der Anfrage',
        Actions: 'Aktionen',
        ApproveRequest: 'Anfrage genehmigen',
        CancelIssuance: 'Ausgabe stornieren',
        ViewComments: 'Kommentare anzeigen',
        ViewAndAddComments: 'Kommentare anzeigen und hinzufügen',
        ApproveRequestSuccessMessage: 'Anfrage wurde genehmigt',
        ApproveRequestErrorMessage: 'Etwas ist schiefgelaufen',
        Pending: 'Ausstehend',
        Completed: 'Abgeschlossen',
        All: 'Alle',
        RequestSubmittedForApproval: 'Anfrage zur Genehmigung eingereicht',
        ApproveDenyModal: {
          Title: 'Sofortbelohnung-Ausgabe genehmigen',
          OkText: 'Genehmigen',
          CancelText: 'Abbrechen',
          Description:
            'Sind Sie sicher, dass Sie diese Sofortbelohnung-Ausgabe genehmigen möchten? Diese Aktion kann nicht rückgängig gemacht werden.'
        }
      },

      RaffleTicketPendingView: {
        RequestID: 'Anfrage-ID',
        Status: 'Status',
        Reason: 'Grund',
        DateOfRequest: 'Datum der Anfrage',
        Actions: 'Aktionen',
        ApproveRequest: 'Anfrage genehmigen',
        CancelIssuance: 'Ausgabe stornieren',
        ViewComments: 'Kommentare anzeigen',
        ViewAndAddComments: 'Kommentare anzeigen und hinzufügen',
        ApproveRequestSuccessMessage: 'Anfrage wurde genehmigt',
        ApproveRequestErrorMessage: 'Etwas ist schiefgelaufen',
        Pending: 'Ausstehend',
        Issued: 'Ausgestellt',
        All: 'Alle',
        RequestSubmittedForApproval: 'Anfrage zur Genehmigung eingereicht',
        ApproveDenyModal: {
          Title: 'Losticket-Ausgabe genehmigen',
          OkText: 'Genehmigen',
          CancelText: 'Abbrechen',
          Description:
            'Sind Sie sicher, dass Sie diese Losticket-Ausgabe genehmigen möchten? Diese Aktion kann nicht rückgängig gemacht werden.'
        }
      },

      AddRemovePointsModal: {
        RequestSubmittedForApproval: 'Anfrage zur Genehmigung eingereicht',
        PointsUpdatedSuccessfully: 'Punkte erfolgreich aktualisiert!',
        ErrorUpdatingPoints: 'Fehler beim Aktualisieren der Punkte',
        AddOrRemovePointsButton: 'Punkte hinzufügen/entfernen',
        AdjustProgressCampaignPoints: 'Fortschrittskampagnenpunkte anpassen',
        OkText: 'Punkte anpassen',
        HowManyPointsToAddOrRemove: 'Wie viele Punkte hinzufügen/entfernen?',
        ReasonForAdjustment: 'Grund für die Anpassung'
      }
    },

    CustomerStamps: {
      All: 'Alle',
      Active: 'Aktiv',
      Inactive: 'Inaktiv',
      Name: 'Name',
      Status: 'Status',
      Started: 'Begonnen',
      Ended: 'Beendet',
      ID: 'AUSWEIS',
      SearchPlaceholder: 'Finden Sie eine Kampagne mit Namen',
      EnrollCampaignModal: {
        SuccessMessage: 'Kampagne eingeschrieben erfolgreich!',
        ErrorMessage: 'Die Registrierung der Kampagne ist fehlgeschlagen.',
        CampaignIDValidationMessage: 'Bitte geben Sie eine Kampagne an',
        FullNameDefault: 'Aktueller Kunde',
        ManualEnrollButton: 'Manuelle Registrierung',
        Title: 'Einschreiben',
        OkText: 'Kunden anmelden',
        CancelText: 'Stornieren'
      },
      CampaignSelectField: {
        Label: 'Kampagne auswählen',
        Edit: 'Bearbeiten',
        Add: 'Hinzufügen',
        Campaign: 'Kampagne'
      },
      CampaignSelectModal: {
        Title: 'Wählen Sie eine Kampagne aus',
        CancelText: 'Stornieren',
        OkText: 'Kampagne hinzufügen',
        SearchPlaceholder: 'Suchen Sie eine Kampagne nach Name, Typ oder Händler',
        Name: 'Name',
        ID: 'AUSWEIS',
        Status: 'Status',
        Tags: 'Tags',
        StartDate: 'Startdatum',
        EndDate: 'Enddatum',

        Active: 'Aktiv',
        Approved: 'Genehmigt'
      }
    },

    CustomerGames: {
      Name: 'Name',
      ID: 'AUSWEIS',
      Status: 'Status',
      GameType: 'Spieltyp',
      TriesRedeemed: 'Versuche eingelöst',
      Started: 'Begonnen',
      Ended: 'Beendet',
      SearchPlaceholder: 'Finden Sie eine Kampagne mit Namen',
      SorrySomethingWentWrong: 'Entschuldigung, etwas ist schief gelaufen',
      Tabs: {
        All: 'Alle',
        Active: 'Aktiv',
        Approved: 'Genehmigt',
        Inactive: 'Inaktiv',
        Ended: 'Beendet'
      }
    }
  }
};
